export enum LotType {
    Default = 0,
    Pick = 1,
    Runout = 2,
}
